/**
 * Text normalisation before comparison.
 *
 * The board fixes the rule: NFKC, then newline folding, then collapsing
 * consecutive whitespace, then **exact** match.
 *
 * One caution that is harmless in Phase 1 and load-bearing later: **NFKC
 * destroys the geometric-tolerance modifier symbols.** The circled letters that
 * denote maximum material condition, least material condition and projected
 * tolerance zone fold into plain letters, so their meaning is lost. Phase 1
 * does not extract those symbols, so nothing is harmed here — but when the
 * later roadmap reads feature control frames, they must be captured *before*
 * this function is applied, or the normalisation quietly erases them.
 */

export function normaliseForComparison(text: string): string {
  return text
    .normalize('NFKC')
    .replace(/\r\n|\r|\n/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/** True when the symbols NFKC would destroy are present. */
export function containsToleranceModifiers(text: string): boolean {
  return /[ⓂⓁⓅ]/.test(text);
}
